import type { Language } from './Screens.js'

/**
 * Routy kurzů — ZAMRZLÁ ČÁST KONTRAKTU.
 *
 * Každá musí být zároveň v `firebase.json` → `rewrites`, jinak refresh
 * vrátí 404 a uživatel přijde o rozdělaný kurz.
 * Viz skill `safetutor-contract` §1.
 */

export interface QuickLessonRoute {
  path: string
  kind: 'quickLesson'
  /** Napevno zadané přihlašovací jméno — kurz se spouští bez přihlášení. */
  username: string
  title: string
  language: Language
  successUrl: string
}

export interface DemoRoute {
  path: string
  kind: 'demo'
  /** Slug se posílá jako `mod_id` i jako název JSONu kurzu. */
  lecture: string
  title: string
  language: Language
  successUrl: string
}

export type CourseRoute = QuickLessonRoute | DemoRoute

/**
 * Přesměrování po dokončení kurzu. Výchozí míří na ostré weby; staging build
 * je přes `VITE_*` (viz `.env.staging`) přesměruje na staging zrcadlo safetutor.org.
 * Produkční řetězce zůstávají znak po znaku stejné — jen se skládají z proměnné.
 */
export const DEMO_SUCCESS = import.meta.env.VITE_DEMO_SUCCESS_URL ?? 'https://www.safetutor.cz/vice'

/**
 * Uživatel dem. Na dokončovací endpoint se s ním nesmí — server by vrátil
 * holé `{"stav":"ERR"}` a uživatel by skončil na stránce s JSONem.
 */
export const DEMO_USER_ID = '0'
const SITE_BASE = import.meta.env.VITE_SITE_BASE ?? 'https://www.safetutor.org'

export const QUICK_LESSONS: QuickLessonRoute[] = [
  {
    path: '/covid19',
    kind: 'quickLesson',
    username: 'U30F2XL443',
    title: 'Školení COVID 19',
    language: 'cze',
    successUrl: `${SITE_BASE}/?page_id=2928`,
  },
  {
    path: '/covid19_eng',
    kind: 'quickLesson',
    username: 'U31F2XE93E',
    title: 'Safety training COVID 19',
    language: 'eng',
    successUrl: `${SITE_BASE}/corona-end-eng`,
  },
]

export const DEMOS: DemoRoute[] = [
  {
    path: '/demo-online_kurz_bozp_zakladni',
    kind: 'demo',
    lecture: 'demo-online_kurz_bozp_zakladni',
    title: 'Kurz BOZP Základní',
    language: 'cze',
    successUrl: DEMO_SUCCESS,
  },
  {
    path: '/demo-online_kurz_obrabeci_stroje',
    kind: 'demo',
    lecture: 'demo-online_kurz_obrabeci_stroje',
    title: 'Kurz Obráběcí Stroje',
    language: 'cze',
    successUrl: DEMO_SUCCESS,
  },
  {
    path: '/demo-online_kurz_bozp_vedouci',
    kind: 'demo',
    lecture: 'demo-online_kurz_bozp_vedouci',
    title: 'Kurz BOZP Vedoucí',
    language: 'cze',
    successUrl: DEMO_SUCCESS,
  },
  {
    path: '/demo-online_kurz_bozp_covid19',
    kind: 'demo',
    lecture: 'demo-online_kurz_bozp_covid19',
    title: 'Kurz BOZP Covid19',
    language: 'cze',
    successUrl: DEMO_SUCCESS,
  },
  {
    path: '/demo-online_kurz_bozp_ridici',
    kind: 'demo',
    lecture: 'demo-online_kurz_bozp_ridici',
    title: 'Kurz BOZP Řídící',
    language: 'cze',
    successUrl: DEMO_SUCCESS,
  },
]

export const COURSE_ROUTES: CourseRoute[] = [...QUICK_LESSONS, ...DEMOS]

/** Cesty, které musí být v `firebase.json` → `rewrites`. */
export const ALL_ROUTE_PATHS: string[] = [
  '/login',
  '/player',
  ...COURSE_ROUTES.map((r) => r.path),
  '/vice',
]
